export default __webpack_public_path__ + "static/media/spinner.1276a431.gif";